import { useDisclosure } from "../../../shared/hooks/useDisclosure";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Grid,
  Divider,
  Avatar,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

import { imagesUrl } from "../../../shared/config";
import { AccessTime, History } from "@mui/icons-material";
import { useMutation } from "@tanstack/react-query";
import { createNotification } from "../../../shared/store/notifications";

function RequestCourseEnrollment({
  children,
  courseData,
  mutationFn,
  onSuccess = () => {},
}) {
  const dialog = useDisclosure();

  const requestEnrollment = useMutation({
    mutationFn,
  });

  const image = courseData?.foto || "";

  async function handleSubscribe() {
    requestEnrollment.mutate(
      {
        cursoid: courseData.cursoid,
        disciplinaid: courseData.disciplinaid,
      },
      {
        onSuccess: (res) => {
          dialog.close();
          createNotification({
            type: "success",
            message: "matrícula criada com sucesso",
          });
          onSuccess(res);
        },
      }
    );
  }

  return (
    <>
      {children(dialog)}
      {Boolean(courseData) && (
        <Dialog open={dialog.isOpen}>
          <DialogTitle>Solicitar inscrição</DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                gap: "2rem",
                py: 2,
              }}
            >
              <Avatar
                sx={{ width: "6rem", height: "6rem" }}
                alt={""}
                src={
                  image.search(/http/) > -1 ? image : `${imagesUrl}/${image}`
                }
              />
              <Box sx={{ flexGrow: 1 }}>
                <Typography fontSize="1rem" fontWeight="600">
                  {courseData?.nome_disciplina}
                </Typography>
                <Typography>{courseData?.nome_curso}</Typography>
                <Grid container spacing={0} paddingY="0.5rem">
                  <Grid
                    item
                    md={6}
                    sx={{
                      display: "flex",
                      gap: "0.2rem",
                      alignItems: "center",
                      height: "2.5rem",
                    }}
                  >
                    <AccessTime color="primary" sx={{ fontSize: "2rem" }} />
                    <Box>
                      <Typography fontSize="0.75rem">Duração</Typography>
                      <Typography fontSize="0.75rem" fontWeight={700}>
                        {`${courseData?.duracao_dias} dias`}
                      </Typography>
                    </Box>
                  </Grid>
                  {Boolean(
                    courseData?.carga_horaria && (
                      <Grid
                        item
                        md={6}
                        sx={{
                          display: "flex",
                          gap: "0.2rem",
                          alignItems: "center",
                          height: "2.5rem",
                        }}
                      >
                        <History color="primary" sx={{ fontSize: "2.1rem" }} />

                        <Box>
                          <Typography fontSize="0.75rem">
                            Carga horária
                          </Typography>
                          <Typography fontSize="0.75rem" fontWeight={700}>
                            {`${courseData?.carga_horaria} horas`}
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  )}
                </Grid>
              </Box>
            </Box>

            <Divider />
            <DialogContentText sx={{ py: 2 }}>
              <div
                dangerouslySetInnerHTML={{ __html: courseData.instrucoes }}
              ></div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 2 }}>
            <Typography variant="caption">
              Ao clicar em "Enviar", sua solicitação será concluída e
              processada. Em breve uma confirmação será enviada para seu e-mail
              de cadastro.
            </Typography>
            <span className="flex flex-row gap-2">
              <Button variant="contained" color="error" onClick={dialog.close}>
                Cancelar
              </Button>
              <Button
                variant="outlined"
                color="success"
                onClick={handleSubscribe}
                disabled={requestEnrollment.isLoading}
              >
                Enviar
                {requestEnrollment.isLoading && (
                  <Box
                    sx={{
                      position: "relative",
                      marginLeft: "1.25rem",
                      marginRight: "0.5rem",
                      marginTop: "0.5rem",
                    }}
                  >
                    <CircularProgress size="15px" />
                  </Box>
                )}
              </Button>
            </span>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

export default RequestCourseEnrollment;
